import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Enlarged real logo mark used as a soft background graphic accent.
// Subtle scroll parallax gives the whole site a gentle sense of depth.
export const Motif = ({ className = "", opacity = 0.5, flip = false, parallax = 18 }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [parallax, -parallax]);

  return (
    <motion.img
      ref={ref}
      src="/logo-mark.png"
      alt=""
      aria-hidden="true"
      className={className}
      style={{
        opacity,
        objectFit: "contain",
        pointerEvents: "none",
        scaleX: flip ? -1 : 1,
        y: parallax ? y : undefined,
      }}
    />
  );
};

// Simple soft blob circle for depth.
export const SoftCircle = ({ className = "", color = "#AEB7A3", opacity = 0.25 }) => (
  <div
    className={className}
    style={{ backgroundColor: color, opacity, borderRadius: "9999px" }}
    aria-hidden="true"
  />
);
